import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
type AccordionItemProps = {
  title: string;
  meta?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
};
export function AccordionItem({
  title,
  meta,
  defaultOpen = false,
  children
}: AccordionItemProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="border-b border-steel-200 bg-white last:border-b-0" data-id="element-26" data-mp="28cygmasc1jc6">
      <h3 data-id="element-27" data-mp="2n2nvf8tcllux">
        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-steel-100" data-id="element-28" data-mp="2n2e85szotssx">
          <span className="font-display text-lg font-semibold uppercase tracking-tight text-ink" data-id="element-29" data-mp="2s3bmtvlho4po">
            {title}
            {meta && <span className="ml-2 font-sans text-xs font-medium normal-case tracking-normal text-steel-400" data-id="element-30" data-mp="11r4mbccnw9ml">
                {meta}
              </span>}
          </span>
          {open ? <MinusIcon className="h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-31" data-mp="3g5ot6ln24duv" /> : <PlusIcon className="h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-32" data-mp="3l3qd18sb4h7e" />}
        </button>
      </h3>
      {open && <div className="px-5 pb-5" data-id="element-33" data-mp="3ut02egvrnlrt">{children}</div>}
    </div>;
}
export function Accordion({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="overflow-hidden rounded-sm border border-steel-200 shadow-card" data-id="element-34" data-mp="3lxatoc0ndh2">
      {children}
    </div>;
}